module.exports = __webpack_public_path__ + "static/media/HelloHeadlineW00-Regular.27b7338a.woff";